import { SendSharp } from '@material-ui/icons';
import {useForm} from 'react-hook-form'
import {useState, useRef} from 'react'

function Loader(){
   return(
      <div className="loader flex-center">
         <img src="/images/loader.svg" className='loader' alt="Loading spinner" />
      </div>
   )
}


const FormComponent = ({modalOpen,setmodalOpen}) => {
const myForm = useRef(null);
const [loading, setLoading] = useState(false)
const {handleSubmit,register,formState:{errors}} = useForm();


const sendValues = data => {
   setLoading(true)
   fetch("https://health-sure.vercel.app/api/folio-message",
   {
      method:"POST",
      headers:{"Content-Type":"application/json"},
      body:JSON.stringify({sender:data.email, title:data.title,message:data.message_body})}
      )
   .then(res=>{
      if(res.ok){
      setLoading(false);
      setmodalOpen(true);
      myForm.current.reset();
   }
      else{
         throw new Error (`Request failed.`);
      }
   })
   .catch(err=>{
      setLoading(false)
      alert(err.message)
   }) 
}

return (
<section className='form-stration'>
{loading && <Loader />}
<form ref={myForm} onSubmit={handleSubmit(sendValues)}>
    <div className="fieldset flex-col">
       <input placeholder=' ' {...register("email", {required:"Come, on...that email is not correct"})}/>
        <label htmlFor='email'> Email: </label>
       {errors.email && <span className='error'>{errors.email.message}</span>}
    </div>
    <div className="fieldset flex-col">
       <input placeholder=' ' id='title' {...register("title", {required:"Please input your designation dear"})}/>
        <label htmlFor='title'> Designation: </label>
       {errors.title && <span className='error'>{errors.title.message}</span>}
    </div>
    <div className="fieldset flex-col">
       <textarea placeholder="  " id='message_body' {...register("message_body", {required:'Come, on, write something'})}></textarea>
        <label htmlFor='message_body'> Message: </label>
       {errors.message_body && <span className='error'>{errors.message_body.message}</span>}
    </div>
    <div className='flex button'>
    <button type='submit'>Send</button>
    <SendSharp />
    </div>
</form>
</section>
    )
}
export default FormComponent



